import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCurrentStyle } from "reducers/authSlice";

export const useStyle = () => {
  const style = useSelector(selectCurrentStyle);

  return useMemo(() => ({ ...style }), [style]);
};
